// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__39LET","rootSuccess":"CompleteLink_rootSuccess__2kgpV","rootFailure":"CompleteLink_rootFailure__3xC15","isDisabled":"CompleteLink_isDisabled__FGFpo"};